import api from '@/api/api-endpoints'
import { createAsyncMutation, doAsyncGet, doAsyncPost, doAsyncPut } from '@/api/async-util'

const types = {
    GET_ALL_ACCOUNT_SETTINGS: createAsyncMutation('GET_ALL_ACCOUNT_SETTINGS'),
    UPDATE_ACCOUNT_SETTING: createAsyncMutation('UPDATE_ACCOUNT_SETTING'),

}

const accountsetting = {
    state: {},
    mutations: {},
    actions: {
        // GET
        getAllAccountSettings(store, customerId) {
            let url = api.accountsetting + 'GetAllAccountSettings/' + customerId
            return doAsyncGet(store, { url, mutationTypes: types.GET_ALL_ACCOUNT_SETTINGS })
        },

        updateAccountSetting(store, payload) {
            let url = api.accountsetting + 'UpdateAccountSetting'
            return doAsyncPost(store, { url, mutationTypes: types.UPDATE_ACCOUNT_SETTING, payload })
        },

    },
    getters: {},
    types: types
}

export default accountsetting
